import { hasAvailableLiquidities } from '../../utils';
import { useAccountAvailableCashLinesTransformApi } from '../api';

export const useAccounsAvailableCashHasLiquidities = () => {
  const accountAvailableCashHasLiquidities = useAccountAvailableCashLinesTransformApi({
    transformFunction: hasAvailableLiquidities,
  });
  return accountAvailableCashHasLiquidities;
};
